import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ResponseModel } from '@dental-ui/account/models';
import { buildApiUrl, buildRequestHeaders } from '@dental-ui/shared/consts';

export interface BrandDto {
  id: string;
  name: string;
  isActive: boolean;
}

export interface PaginationData<T> {
  data: T[];
  totalPage: number;
  totalRecord: number;
}

@Injectable({ providedIn: 'root' })
export class PortalBrandsApiService {
  private readonly http = inject(HttpClient);

  getBrands(page: number, pageSize: number, name?: string): Observable<PaginationData<BrandDto>> {
    const body = {
      PaginationRequestModel: {
        page: page + 1,
        numberOfRecord: pageSize,
        sortColumn: '',
        sortOrder: '',
      },
      BrandFilterRequestDto: { name: name ?? '' },
    };
    return this.http
      .post<ResponseModel<PaginationData<BrandDto>>>(
        buildApiUrl('brand.getAllByFilter'),
        body,
        { headers: buildRequestHeaders(true) }
      )
      .pipe(map((res) => res.data ?? { data: [], totalPage: 0, totalRecord: 0 }));
  }

  getAllBrands(): Observable<BrandDto[]> {
    return this.http
      .get<ResponseModel<PaginationData<BrandDto>>>(buildApiUrl('brand.getAll'), {
        headers: buildRequestHeaders(true),
      })
      .pipe(map((res) => res.data?.data ?? []));
  }

  createBrand(model: Omit<BrandDto, 'id'>): Observable<unknown> {
    return this.http.post(buildApiUrl('brand.create'), model, {
      headers: buildRequestHeaders(true),
    });
  }

  updateBrand(model: BrandDto): Observable<unknown> {
    return this.http.put(buildApiUrl('brand.update'), model, {
      headers: buildRequestHeaders(true),
    });
  }

  deleteBrand(id: string): Observable<unknown> {
    return this.http.delete(`${buildApiUrl('brand.delete')}?Brand=${id}`, {
      headers: buildRequestHeaders(true),
    });
  }
}
